<template>
  <RevContainer class="mx-auto max-w-[760px] md:py-32">
    <section class="space-y-32">
      <header>
        <h1 class="heading-1">{{ i18n(translations.heading) }}</h1>
        <p>
          {{ i18n(translations.firstParagraph) }}
        </p>
      </header>

      <BouyguesAssistanceInfoBlock />
    </section>
  </RevContainer>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContainer } from '@ds/components/Container'

import BouyguesAssistanceInfoBlock from '../ExpiredError/components/BouyguesAssistanceInfoBlock/BouyguesAssistanceInfoBlock.vue'

import translations from './CanceledError.translations'

const i18n = useI18n()
</script>
